import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { RequestBonusCardWrapper } from "@/components/Account/RequestBonusCard/requestBonusCard.wrapper";
import * as OrderDetailsSelectors from "@/redux/modules/api/data/orderDetail/orderDetail.selectors";
import * as BonusCardService from "@/services/bonusCard.service";
import { BonusCardStatus } from "@/utils/enums";

import { RequestBonusCardBlockComponent } from "./requestBonusCardBlock.component";

const RequestBonusCardBlock = () => {
    const orderDetails = useSelector(OrderDetailsSelectors.getOrder);
    const isOrderDetailsLoading = useSelector(OrderDetailsSelectors.isLoading);

    const [bonusCardStatus, setBonusCardStatus] = useState(
        orderDetails?.customer
            ? BonusCardService.getStatus({
                  email: orderDetails.customer.email,
                  bonusCardNumber:
                      orderDetails.bonusCardNumber ??
                      orderDetails.sessionCustomer?.bonusCardNumber,
                  eBonusCardNumber:
                      orderDetails.sessionCustomer?.eBonusCardNumber,
                  bonusCardRequested:
                      orderDetails.sessionCustomer?.bonusCardRequested
              })
            : BonusCardStatus.NoCard
    );

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        setBonusCardStatus(
            orderDetails?.customer
                ? BonusCardService.getStatus({
                      email: orderDetails.customer.email,
                      bonusCardNumber:
                          orderDetails.bonusCardNumber ??
                          orderDetails.sessionCustomer?.bonusCardNumber,
                      eBonusCardNumber:
                          orderDetails.sessionCustomer?.eBonusCardNumber,
                      bonusCardRequested:
                          orderDetails.sessionCustomer?.bonusCardRequested
                  })
                : BonusCardStatus.NoCard
        );
    }, [orderDetails?.customer]);

    if (
        isOrderDetailsLoading ||
        !orderDetails ||
        bonusCardStatus === BonusCardStatus.HasCard
    ) {
        return null;
    }

    return (
        <RequestBonusCardWrapper
            customer={{
                firstName: orderDetails?.customer.firstName,
                lastName: orderDetails?.customer.lastName,
                email: orderDetails?.customer.email,
                dateOfBirth:
                    orderDetails.sessionCustomer?.dateOfBirth ?? undefined,
                favouriteStoreId:
                    orderDetails.sessionCustomer?.favouriteStoreId ??
                    orderDetails?.store?.code
            }}
            bonusCardStatus={bonusCardStatus}
            address={{
                street: orderDetails.billingAddress?.street,
                number: orderDetails.billingAddress?.number,
                zipCode: orderDetails.billingAddress?.zipCode,
                city: orderDetails.billingAddress?.city,
                box: orderDetails.billingAddress?.box,
                country: orderDetails.billingAddress?.countryIsoCode
            }}
            onSubmit={() => setBonusCardStatus(BonusCardStatus.Requested)}
        >
            {({ openModal, bonusCardStatus }) => (
                <RequestBonusCardBlockComponent
                    openModal={openModal}
                    bonusCardStatus={bonusCardStatus}
                />
            )}
        </RequestBonusCardWrapper>
    );
};

export { RequestBonusCardBlock };
